const renderBranding = (show_powered_by) => {
  if (show_powered_by) {
    return `<span class="moveo__copy"><a href="https://moveo.ai" target="_blank">We run on Moveo.ai <span><svg width="12" height="11" fill="#8499A8" xmlns="http://www.w3.org/2000/svg"><rect x="4.859" y="3.583" width="3.583" height="7.084" rx="1.791" transform="rotate(-90 4.86 3.583)" /><ellipse cx="2.487" cy="7.869" rx="2.487" ry="2.516" /><ellipse cx="1.451" cy="1.747" rx="1.451" ry="1.467" /><ellipse cx="8.382" cy="7.799" rx="1.451" ry="1.467"/></svg></a></span>`;
  }
  return `<span class="moveo__copy moveo__empty"></span>`;
};

export default renderBranding;
